import { create } from 'zustand';
import apiClient from '../api/client';
import Alertas from '../alerts/AlertasGernericos';
import { TrySharp } from '@mui/icons-material';

export const useProdutosStore = create((set, get) => ({

    // GET
    carregando: false,
    logado: false,
    produtos: [],
    pagina_atual: 1,
    ultima_pagina: 0,
    hanking_de_produtos: [],
    total_de_produtos_ja_vendidos: 0,
    mostrar_grafico: true,
    deletingId: 0,
    grupos: [],
    sub_grupos: [],
    erro_no_codigo_de_consulta: false,
    filtrosDeBusca: null,
    dadosProdsVendidosParaGrafico: [],
    dadosFitroParaGrafico: null,

    // Setters
    setCarregando: (valor) => set({ carregando: valor }),
    setLogado: (valor) => set({ logado: valor }),
    setProdutos: (produtos) => set({ produtos }),
    setPaginaAtual: (pagina) => set({ pagina_atual: pagina }),
    setUltimaPagina: (pagina) => set({ ultima_pagina: pagina }),
    setHankingDeProdutos: (dados) => set({ hanking_de_produtos: dados }),
    setTotalVendidos: (total) => set({ total_de_produtos_ja_vendidos: total }),
    setMostrarGrafico: (valor) => set({ mostrar_grafico: valor }),
    setFiltroDeBusca: (filtros) => set({ filtrosDeBusca: filtros }),
    seterroCodigoConsultaProduto: (valor) => set({ erro_no_codigo_de_consulta: valor }),
    seProdutosParaGrafico: (valor) => set({ dadosProdsVendidosParaGrafico: valor }),


    GetProdutosHanking: async () => {
        try {
            set({ carregando: true });

            const resposta = await apiClient.get('/gethankProdutos')

            const data = resposta.data;

            if (!data || !data.ranking_produtos) {
                throw new Error("Não foi possível carregar os produtos mais vendidos.");
            }

            // Não mostrar o grafico caso não tenha vendas no mês.
            if (data.total_de_produtos_venidos === '0') {
                set({ mostrar_grafico: false });
                return
            }

            set({
                hanking_de_produtos: data.ranking_produtos,
                carregando: false,
                total_de_produtos_ja_vendidos: data.total_de_produtos_venidos
            });

        } catch (err) {
            set({ carregando: false });
            Alertas.ExibirAlertaErro(err.message || "Erro desconhecido ao buscar produtos.");
        }
    },

    GetProdutos: async () => {
        try {
            set({ carregando: true });

            const { pagina_atual } = get();

            const resposta = await apiClient.get('/getProdutos', {
                params: { page: pagina_atual }
            });

            const data = resposta.data;

            if (!data || !data.produtos) {
                throw new Error("Não foi possível carregar os produtos.");
            }

            set({
                produtos: data.produtos,
                pagina_atual: data.pagina_atual,
                ultima_pagina: data.ultima_pagina,
                carregando: false
            });

        } catch (err) {
            set({ carregando: false });
            Alertas.ExibirAlertaErro(err.message || "Erro desconhecido ao buscar produtos.");
        }
    },

    proximaPagina: () => {
        const { pagina_atual, ultima_pagina, GetProdutos } = get();
        if (pagina_atual < ultima_pagina) {
            set({ pagina_atual: pagina_atual + 1 }, GetProdutos);
        }
    },

    paginaAnterior: () => {
        const { pagina_atual, GetProdutos } = get();
        if (pagina_atual > 1) {
            set({ pagina_atual: pagina_atual - 1 }, GetProdutos);
        }
    },

    fetchGruposEsubgrupos: async (page = 1) => {
        set({ carregando: 'fetching' });
        try {
            const response = await apiClient.get('/GetGruposEsubgrupos');

            const { grupos, subgrupos } = response.data;

            set({
                grupos: grupos,
                sub_grupos: subgrupos
            });

        } catch (error) {
            Alertas.ExibirAlertaErro(error.response?.data?.message || "Erro ao buscar grupos e subgrupos.");
            set({ carregando: 'idle' });
        } finally {
            set({ carregando: 'idle' });
        }
    },

    searchProdutos: async (filtros) => {

        set({ carregando: 'searching', pagina_atual: 1 });

        try {
            const response = await apiClient.post('/PesquisarProdutos', {
                nome: filtros.nome,
                cod_produto: filtros.cod_produto,
                status: filtros.status,
                cod_grupo: filtros.cod_grupo,
                cod_subgrupo: filtros.cod_subgrupo,
                cod_consulta: filtros.cod_consulta
            });

            const { data, last_page, current_page } = response.data.dados;

            set({
                produtos: data,
                ultima_pagina: last_page,
                pagina_atual: current_page,
                carregando: 'idle'
            });

        } catch (error) {
            Alertas.ExibirAlertaErro(error.response?.data?.message || "Não foi encotrado nenhum produto com esses dados.");
            set({ carregando: 'idle' });
        }
    },

    fetchProdutos: async (page = 1) => {
        set({ carregando: 'fetching' });
        try {
            const response = await apiClient.get('/GetProdutosFiltrados', {
                params: { page }
            });
            const { data, last_page, current_page } = response.data.dados;

            set({
                produtos: data,
                ultima_pagina: last_page,
                pagina_atual: current_page,
                carregando: 'idle',
            });
        } catch (error) {
            Alertas.ExibirAlertaErro(error.response?.data?.message || "Erro ao buscar produtos.");
            set({ carregando: 'idle' });
        }
    },

    deleteProduto: async (cod_do_produto) => {

        set({ deletingId: cod_do_produto }); // Mostra o loading apenas na linha a ser excluída
        try {
            const { Relaod } = get();
            let response = await apiClient.post('/ExcluirProduto', { cod_produto: cod_do_produto });

            if (!response) {
                throw new Error("Ocorreu um erro de conexão, verifique se você tem acesso a internet.");
            }

            const { erro, message } = response.data;

            if (erro) {
                throw new Error(message);
            }

            // Atualiza a lista
            await Relaod();
            Alertas.ExibirAlertaSucesso(message);


        } catch (error) {
            Alertas.ExibirAlertaErro(error?.message || "Erro ao excluir produto.");
        } finally {
            set({ deletingId: null });
        }
    },

    updateProdutos: async (produto_data) => {
        set({ carregando: 'updating' });
        try {
            const { Relaod } = get();
            const response = await apiClient.post('/AtualizarProduto', {
                cod_consulta: produto_data.cod_consulta,
                cod_grupo: produto_data.cod_grupo,
                cod_produto: produto_data.cod_produto,
                cod_subgrupo: produto_data.cod_subgrupo,
                nome: produto_data.nome,
                status: produto_data.status,
                valor: produto_data.valor,
            });


            if (!response) {
                throw new Error("Ocorreu um erro de conexão, verifique se você tem acesso a internet.");
            }

            const { erro, message } = response.data;

            if (erro) {
                throw new Error(message);
            }

            // Atualiza a lista
            await Relaod();
            Alertas.ExibirAlertaSucesso(message);
            return true;

        } catch (error) {
            Alertas.ExibirAlertaErro(error.response?.data?.message || "Erro ao atualizar produto.");
            set({ carregando: 'idle' });
            return false;
        } finally {
            set({ carregando: 'idle' });
        }
    },

    CreateProduto: async (produtosData) => {
        try {
            set({ carregando: 'creating' });

            const response = await apiClient.post('/CriarProduto', {
                nome: produtosData.nome,
                valor: produtosData.valor,
                status: produtosData.status,
                cod_grupo: produtosData.cod_grupo,
                cod_consulta: produtosData.cod_consulta,
                cod_subgrupo: produtosData.cod_subgrupo,

            });

            if (!response) {
                throw new Error("Ocorreu um erro de conexão, verifique se você tem acesso a internet.");
            }

            const { erro, message } = response.data;

            //  já existe um código de consulta.
            if (response.status == 202) {
                console.log("erro no codigo de consulta")
                set({ carregando: 'idle', erro_no_codigo_de_consulta: true });
                return
            }

            if (erro) {
                throw new Error(message);
            }

            // Atualiza a lista
            await get().fetchProdutos(get().pagina_atual);
            Alertas.ExibirAlertaSucesso(message);
            set({ carregando: 'idle', erro_no_codigo_de_consulta: false });
            return true;

        } catch (error) {
            Alertas.ExibirAlertaErro(error.message || "Erro ao criar produto.");
            set({ carregando: 'idle' });
            return false;
        } finally {
            set({ carregando: 'idle' });
        }
    },

    Relaod: async () => {

        const { filtrosDeBusca, fetchProdutos } = get();

        if (filtrosDeBusca) {
            get().searchProdutos(filtrosDeBusca);
            return;
        }

        fetchProdutos(get().pagina_atual);
    },

    FiltrarProdutosParaGrafico: async (filtros) => {
        try {
            set({ carregando: 'find' });
            const response = await apiClient.get('/getProdutosVendidos', {
                params: {
                    data_fim: filtros.data_fim,
                    data_inicio: filtros.data_inicio,
                    grupo: filtros.grupo,
                    subgrupo: filtros.subgrupo,
                    qtd_registros: filtros?.qtd_registros || '10',
                    nome_produto: filtros.nome_produto,
                }
            });

            if (!response) {
                throw new Error("Ocorreu um erro de conexão, verifique se você tem acesso a internet.");
            }

            const { erro, message, produtos } = response.data;

            if (erro) {
                throw new Error(message);
            }


            if (produtos.length === 0) {
                throw new Error('Nenhum dado encontrado');
            }

            set({
                dadosProdsVendidosParaGrafico: produtos,
                dadosFitroParaGrafico: filtros,
                carregando: 'idle'
            });
        } catch (error) {
            Alertas.ExibirAlertaErro(error.message || "Erro ao filtrar produtos.");
            set({ carregando: 'idle' });
            return false;
        } finally {
            set({ carregando: 'idle' });
        }
    },

    // FiltrarProdutosParaGrafico: async (filtros) => {
    //     try {

    //         const response = await apiClient.get('/getProdutosVendidos', {
    //             params: {
    //                 data_fim: filtros.data_fim,
    //                 data_inicio: filtros.data_inicio,
    //                 grupo: filtros.grupo,
    //                 subgrupo: filtros.subgrupo,
    //                 qtd_registros: filtros.qtd_registros,
    //                 nome_produto: filtros.nome_produto,
    //             }
    //         });

    //         console.log("teste de dados", response)
    //         if (!response) {
    //             throw new Error("Ocorreu um erro de conexão, verifique se você tem acesso a internet.");
    //         }

    //         const { erro, message, produtos } = response.data;

    //         if (erro) {
    //             throw new Error(message);
    //         }

    //         set({ dadosProdsVendidosParaGrafico: produtos });

    //     } catch (error) {
    //         Alertas.ExibirAlertaErro(error.message || "Erro ao criar produto.");
    //         set({ carregando: 'idle' });
    //         return false;
    //     } finally {
    //         set({ carregando: 'idle' });
    //     }
    // },


}));
